module.exports = __webpack_public_path__ + "static/media/gallery8.34337439.jpg";